<template>
  <div>
    学生个人成绩
  </div>
</template>

<script>
export default {
  components: {

  },
  data() {
    return {

    }
  },
  methods: {
  },
}
</script>
<style>
</style>
